import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22.954,
	height: 23,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Icon - Support",
		children: /* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			"data-name": "Group 1696",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M2.915 9.66a8.54 8.54 0 0 1 17.059-.808c.013.268.013.538 0 .808",
					"data-name": "Path 5122"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.731 17.511a8.519 8.519 0 0 1-5.575 3.471",
					"data-name": "Path 5123"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.525 15.197a2.16 2.16 0 0 1-1.808 2.457 2.151 2.151 0 0 1-2.42-1.807l-.553-3.71a2.14 2.14 0 0 1 1.773-2.454h.022a2.153 2.153 0 0 1 2.422 1.832Z",
					"data-name": "Path 5124"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.422 15.196a2.142 2.142 0 0 0 4.188.9 2.522 2.522 0 0 0 .039-.254l.554-3.709a2.134 2.134 0 1 0-4.2-.759 4.92 4.92 0 0 0-.02.136Z",
					"data-name": "Path 5125"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.445 18.707a1.788 1.788 0 1 1-1.779 1.789 1.783 1.783 0 0 1 1.779-1.789Z",
					"data-name": "Path 5126"
				})
			]
		})
	})
});
export { SvgIconHelp as ReactComponent };
